// extracted by mini-css-extract-plugin
module.exports = {"total":"_927a99ad28--total--T0sSe","dashed_line":"_927a99ad28--dashed_line--N5jAY","price_wrapper":"_927a99ad28--price_wrapper--fMcwE"};